import BlogCategoryService from '@/services/BlogCategoryService'

const createBlogCategoriesModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    blogCategories: []
  },
  actions: {
    getBlogCategories: ({ commit, state }) => {
      BlogCategoryService.getBlogCategories(state.pageSize, state.page)
        .then((data) => {
          commit('SET_BLOG_CATEGORIES', {
            blogCategories: data.blogCategories
          })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, commit, state }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getBlogCategories')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_BLOG_CATEGORIES: (state, { blogCategories }) => {
      state.blogCategories = blogCategories
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createBlogCategoriesModule
